import { Button, Link, SystemIcon, Typography } from '@volvo/vcdk-react';
import { Trans, useTranslation } from 'react-i18next';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';
import {
  campaignsRecallLink,
  manualsAndHandbooksBaseLink,
  productArchiveLinkIndustrialOffroad,
  productArchiveLinkIndustrialPowerGeneration,
  sparePartsBaseLink,
  supportLink,
} from '@/utils/baseLinks';

type Props = {
  engineSerials: string[];
  onCancel: () => void;
  onNext: () => void;
};

const IndustrialNoUnitAddedContent: React.FC<Props> = ({ engineSerials, onCancel, onNext }) => {
  const { t } = useTranslation();

  return (
    <>
      <span slot="header">{t(($) => $.components.modal.add_new_unit_modal.industrial_no_unit_added.title)}</span>
      <div className="flex flex-col gap-8">
        <Typography>{t(($) => $.components.modal.add_new_unit_modal.industrial_no_unit_added.description)}</Typography>
        <div className="flex flex-col gap-4">
          <Typography variant="subtitle2">
            {t(($) => $.components.modal.add_new_unit_modal.industrial_no_unit_added.manual_registration)}
          </Typography>
          <Typography>
            <Trans
              i18nKey={($) =>
                $.components.modal.add_new_unit_modal.industrial_no_unit_added.manual_registration_description
              }
              components={{
                b: <strong />,
              }}
            />
          </Typography>
        </div>
        <div className="flex flex-col gap-4">
          <Typography variant="subtitle2">
            {t(($) => $.components.modal.add_new_unit_modal.industrial_no_unit_added.manuals_campaigns)}
          </Typography>
          <Typography>
            {t(($) => $.components.modal.add_new_unit_modal.industrial_no_unit_added.manuals_campaigns_description)}
          </Typography>
        </div>
        <ul className="flex flex-col gap-6">
          <li className="flex items-center gap-2">
            <SystemIcon icon="question-mark" className="[&::part(svg)]:text-link" />
            <Link href={supportLink} target="_blank">
              Support
            </Link>
          </li>
          <li className="flex items-center gap-2">
            <SystemIcon icon="book" className="[&::part(svg)]:text-link" />
            <Link href={`${manualsAndHandbooksBaseLink}${engineSerials[0] ?? ''}`} target="_blank">
              Manual and handbooks
            </Link>
          </li>
          <li className="flex items-center gap-2">
            <SystemIcon icon="manage-settings" className="[&::part(svg)]:text-link" />
            <Link href={`${sparePartsBaseLink}${engineSerials.join(',')}`} target="_blank">
              Spare parts
            </Link>
          </li>
          <li className="flex items-center gap-2">
            <SystemIcon icon="campaign" className="[&::part(svg)]:text-link" />
            <Link href={campaignsRecallLink} target="_blank">
              Campaigns
            </Link>
          </li>
          <li className="flex items-center gap-2">
            <SystemIcon icon="history" className="[&::part(svg)]:text-link" />
            <Link href={productArchiveLinkIndustrialOffroad} target="_blank">
              Product archive Industrial Off-road
            </Link>
          </li>
          <li className="flex items-center gap-2">
            <SystemIcon icon="history" className="[&::part(svg)]:text-link" />
            <Link href={productArchiveLinkIndustrialPowerGeneration} target="_blank">
              Product archive Industrial Power Generation
            </Link>
          </li>
        </ul>
      </div>

      <span slot="modalFooter">
        <div className="flex gap-4">
          <Button variant="secondary" onClick={onCancel}>
            {t(($) => $.components.modal.add_new_unit_modal.industrial_no_unit_added.add_another_unit)}
          </Button>
          <Button variant="primary" onClick={onNext}>
            {t(($) => $.common.close)}
          </Button>
        </div>
      </span>
    </>
  );
};

export default withComponentErrorBoundary(IndustrialNoUnitAddedContent);
